// File Metadata:
// Filename: UserDashboard.js
// Version: 1.00
// Created: 2025-03-28 20:07:09
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { Grid, Box } from '@mui/material'
import MedicalStatusCard from './MedicalStatusCard'
import CrewSchedule from './crew/CrewSchedule'
import CompetencyList from './CompetencyList'
import TrainingProgress from './TrainingProgress'
import SkillsOverview from './SkillsOverview'

const UserDashboard = ({ userId }) => {
    return (
        <Box sx={{ p: 2 }}>
            <Grid container spacing={3}>
                {/* Quick Status Row */}
                <Grid item xs={12} md={4}>
                    <MedicalStatusCard userId={userId} />
                </Grid>
                <Grid item xs={12} md={8}>
                    <CrewSchedule crewId={userId} />
                </Grid>

                {/* Training & Skills Row */}
                <Grid item xs={12} md={6}>
                    <TrainingProgress userId={userId} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <SkillsOverview userId={userId} />
                </Grid>

                {/* Competencies Overview */}
                <Grid item xs={12}>
                    <CompetencyList userId={userId} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default UserDashboard
